export const userProfilePath = '__user-profile__';
export const userSettingsPath = '__user-settings__';
export const alertStoragePath = '__user-alerts__';
